(ns ballot-scout-v2-frontend.widget.subs
  (:require
   [ballot-scout-v2-frontend.util :as util]
   [re-frame.core :as rf]))

(rf/reg-sub
 ::widget-search-params
 (fn [db]
   (get-in db [:widget :search-params])))

(rf/reg-sub
 ::widget-voter-response
 (fn [db]
   (get-in db [:widget :voter-response])))

(rf/reg-sub
 ::widget-ballot-response
 (fn [db]
   (filter #(util/within-six-months? (:election/date (:ballot/election %)))
           (get-in db [:widget :ballot-response]))))

(rf/reg-sub
 ::widget-ballot-id
 (fn [db]
   (get-in db [:widget :ballot-id])))

(rf/reg-sub
 ::widget-ballot
 :<- [::widget-ballot-id]
 :<- [::widget-ballot-response]
 (fn [[id ballot-response]]
   (first (filter #(= (:ballot/id %) id) ballot-response))))

(rf/reg-sub
 ::widget-phase
 (fn [db]
   (get-in db [:widget :phase])))

(rf/reg-sub
 ::widget-type
 (fn [db]
   (get-in db [:widget :type])))

(rf/reg-sub
 ::widget-partner
 (fn [db]
   (get-in db [:widget :partner])))

(rf/reg-sub
 ::widget-jurisdiction
 (fn [db]
   (get-in db [:widget :jurisdiction])))

(rf/reg-sub
 ::widget-sms-subscribe-status
 (fn [db]
   (get-in db [:widget :subscriptions :sms :subscribe])))

(rf/reg-sub
 ::widget-email-subscribe-status
 (fn [db]
   (get-in db [:widget :subscriptions :email :subscribe])))

(rf/reg-sub
 ::widget-sms-unsubscribe-status
 (fn [db]
   (get-in db [:widget :subscriptions :sms :unsubscribe])))

(rf/reg-sub
 ::widget-email-unsubscribe-status
 (fn [db]
   (get-in db [:widget :subscriptions :email :unsubscribe])))

(rf/reg-sub
 ::widget-received-stopcode
 (fn [db]
   (get-in db [:widget :subscriptions :sms :stopcode-received :stopcode-received/to-number])))

(rf/reg-sub
 ::widget-language
 (fn [db]
   (get-in db [:widget :langcode])))

(rf/reg-sub
 ::widget-contact-info
 :<- [::widget-partner]
 :<- [::widget-jurisdiction]
 :<- [::widget-type]
 (fn [[current-partner current-jurisdiction widget-type]]
   (if (= widget-type :partner)
     {:name (:partner/name current-partner)
      :phone (:partner/phone current-partner)
      :email (:partner/email current-partner)}
      ;else jurisdiction widget
     {:name (or (:jurisdiction/name current-jurisdiction) (:partner/name current-partner))
      :phone (or (:jurisdiction/phone current-jurisdiction) (:partner/phone current-partner))
      :email (or (:jurisdiction/email current-jurisdiction) (:partner/email current-partner))})))
